import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const styles = {
  button: {
    backgroundColor: '#452188',
    height: '42px',
    boxShadow: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ffffff',
    padding: '8px 22px',
    '&:hover': {
      backgroundColor: '#452188',
      boxShadow: 'none',
    },
  },
  icon: {
    marginRight: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    fontSize: '0.9375rem',
    fontWeight: 400,
    textTransform: 'none',
  },
};

const FilledButton = ({ icon, text, classes, handleClick }) => {
  return (
    <Button
      variant="contained"
      className={classes.button}
      onClick={handleClick}
    >
      {icon && <span className={classes.icon}>{icon}</span>}
      {text && <span className={classes.text}>{text}</span>}
    </Button>
  );
};

FilledButton.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.any,
  handleClick: PropTypes.func,
};

export default withStyles(styles as any, { withTheme: true })(FilledButton);
